// const AppURL =
//   "http://192.168.0.115/projects/vinote-backend-laravel/public/api/";
// const AppURL = "https://admin.vinoted.servepratham.com/api/";
const AppURL = "https://www.admin.vinoted-admin.com/api/";

export default AppURL;
